import React, {useMemo} from 'react';

export interface SvgRendererProps {
  readonly content: string;
  readonly maxWidth?: number;
  readonly maxHeight?: number;
}

/**
 * 清理 SVG 内容，移除潜在危险元素
 */
const sanitizeSvg = (svgContent: string): string => {
  let cleaned = svgContent.replace(/<script[\s\S]*?<\/script>/gi, '');
  cleaned = cleaned.replace(/\s+on\w+\s*=\s*["'][^"']*["']/gi, '');
  cleaned = cleaned.replace(/javascript:/gi, '');
  return cleaned;
};

/**
 * 兜底：确保传入的内容是反转义后的真实 SVG
 * 防止上游遗漏转义处理
 */
const ensureUnescaped = (text: string): string => {
  let result = text;

  // 去除首尾包裹引号
  if (result.startsWith('"') && result.endsWith('"')) {
    result = result.slice(1, -1);
  }

  // 如果仍包含 JSON 转义序列，进行反转义
  if (/\\n|\\"/g.test(result)) {
    result = result.replace(/\\n/g, '\n');
    result = result.replace(/\\t/g, '\t');
    result = result.replace(/\\"/g, '"');
    result = result.replace(/\\\\/g, '\\');
  }

  return result;
};

export const SvgRenderer: React.FC<SvgRendererProps> = ({
  content,
  maxWidth = 600,
  maxHeight = 400
}) => {
  const sanitizedSvg = useMemo(() => {
    const unescaped = ensureUnescaped(content);
    return sanitizeSvg(unescaped);
  }, [content]);

  return (
    <div
      className="svg-renderer"
      style={{maxWidth, maxHeight}}
    >
      <div
        className="svg-content"
        dangerouslySetInnerHTML={{__html: sanitizedSvg}}
      />
    </div>
  );
};